import { useMemo } from "react";

import Box from "ds/components/Box";
import { RunWorkerMetrics } from "types/generated";

import { getSlowestHookGroups, getSlowestProviderGroups, getSlowestResourceGroups } from "./utils";
import RunObservabilitySlowestItemsCard from "./Card";

type RunObservabilitySlowestItemsProps = {
  workerMetrics: RunWorkerMetrics;
};

const RunObservabilitySlowestItems = ({ workerMetrics }: RunObservabilitySlowestItemsProps) => {
  const { slowestResources, slowestHooks, slowestProviders } = useMemo(
    () => ({
      slowestResources: getSlowestResourceGroups(workerMetrics.states),
      slowestHooks: getSlowestHookGroups(workerMetrics.states),
      slowestProviders: getSlowestProviderGroups(
        workerMetrics.slowestProviders,
        workerMetrics.duration.seconds
      ),
    }),
    [workerMetrics]
  );

  return (
    <Box grid gridTemplate="repeat(auto-fit, minmax(30rem, 1fr))" gap="large" fullWidth>
      <RunObservabilitySlowestItemsCard
        title="Slowest resources"
        emptyTitle="No resource timings for this run"
        emptyPhaseTitle="No resource timings for this phase"
        groups={slowestResources}
      />
      <RunObservabilitySlowestItemsCard
        title="Slowest hooks"
        emptyTitle="No hook timings for this run"
        emptyPhaseTitle="No hook timings for this phase"
        groups={slowestHooks}
      />
      <RunObservabilitySlowestItemsCard
        title="Slowest provider installs"
        emptyTitle="No provider install timings for this run"
        groups={slowestProviders}
      />
    </Box>
  );
};

export default RunObservabilitySlowestItems;
